// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Font family global */
.font_Inter {
  font-family: "Inter", sans-serif !important;
}

.font_DM_Sans {
  font-family: "DM Sans", sans-serif !important;
}

.font_Inter_Tight {
  font-family: "Inter Tight", sans-serif !important;
}

/* INLINE___BLOCK */
.display_Inline_Block {
  display: inline-block;
}

/* flex properties */
.display_flex {
  display: flex;
}

.row_flex {
  display: flex;
  flex-direction: row;
}

.col_flex {
  display: flex;
  flex-direction: column;
}

.row_flex_center {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.col_flex_center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.align_center {
  display: flex;
  align-items: center;
}

.displayAlignCenterJustifyBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.justify_space_between {
  display: flex;
  justify-content: space-between;
}

.justify_space_around {
  justify-content: space-around;
}

.justify_space_evenly {
  justify-content: space-evenly;
}

.justify_center {
  justify-content: center;
}

.justify_start {
  justify-content: flex-start !important;
}

.justify_none {
  justify-content: none;
}

.justify_normal {
  justify-content: normal !important;
}

.justify_end {
  justify-content: flex-end;
}

.align_items_center {
  align-items: center;
}

.align_start {
  align-items: flex-start;
}

.align_end {
  align-items: flex-end;
}

.align_baseline {
  display: flex;
  align-items: baseline;
}

.flex_wrap {
  flex-wrap: wrap;
}

/* ------GAP----- */
.gap_2 {
  gap: 2px;
}

.gap_4 {
  gap: 4px;
}

.gap_6 {
  gap: 6px;
}

.gap_8 {
  gap: 8px;
}

.gap_10 {
  gap: 10px;
}

.gap_12 {
  gap: 12px;
}

.gap_14 {
  gap: 14px;
}

.gap_16 {
  gap: 16px;
}

.gap_20 {
  gap: 20px;
}

.gap_24 {
  gap: 24px;
}

.gap_30 {
  gap: 30px;
}

.gap_36 {
  gap: 36px;
}

.gap_50 {
  gap: 50px;
}

/* -----BORDER-RADIUS------ */
.borderRadius_6 {
  border-radius: 6px;
}

.borderRadius_10 {
  border-radius: 10px;
}

.borderRadius_16 {
  border-radius: 16px;
}

.border_none {
  border: none !important;
}

/* font weight */
.font_300 {
  font-weight: 300;
}

.font_400 {
  font-weight: 400;
}

.font_500 {
  font-weight: 500;
}

.font_600 {
  font-weight: 600;
}

.font_700 {
  font-weight: 700;
}

.font_bold {
  font-weight: bold;
}

.font_normal {
  font-weight: normal;
}

/* cursor properties */
.cursor_pointer {
  cursor: pointer;
}

.cursor_not_allowed {
  cursor: not-allowed;
}

.cursor_default {
  cursor: default;
}

/* position properties */
.pos_relative {
  position: relative;
}

.pos_absolute {
  position: absolute;
}

.bottom_30 {
  bottom: 3rem;
}

.zIndex_1 {
  z-index: 1;
}

.zIndex_100000 {
  z-index: 100000;
}

/* text align properties */
.text_center {
  text-align: center;
}

.text_left {
  text-align: left;
}

.text_right {
  text-align: right;
}

.text_capitalize {
  text-transform: capitalize;
}

.text_uppercase {
  text-transform: uppercase;
}

/* font-size */
.fontSize_10 {
  font-size: 10px;
}

.fontSize_12 {
  font-size: 12px;
}

.fontSize_14 {
  font-size: 14px;
}

.fontSize_15 {
  font-size: 15px;
}

.fontSize_16 {
  font-size: 16px;
}

.fontSize_18 {
  font-size: 18px;
}

.fontSize_20 {
  font-size: 20px;
}

.fontSize_22 {
  font-size: 22px;
}

.fontSize_24 {
  font-size: 24px;
}

.fontSize_36 {
  font-size: 36px;
}

/* -----LINEHEIGHT------- */
.lineHeight_normal {
  line-height: normal;
}

.lineHeight_24 {
  line-height: 24px;
}

.lineHeight_20 {
  line-height: 20px;
}

/* height and width */
.h_100 {
  height: 100%;
}

.h_100vh {
  height: 100vh;
}

.h_30px {
  height: 30px;
}

.h_maxContent {
  height: -webkit-max-content;
  height: max-content;
}

.w_100 {
  width: 100%;
}

.w_50 {
  width: 50%;
}

.w_75 {
  width: 75%;
}

.w_25 {
  width: 25%;
}

.w_auto {
  width: auto !important;
}

.w_fit_content {
  width: -webkit-fit-content !important;
  width: fit-content !important;
}

.w_max_content {
  width: -webkit-max-content;
  width: max-content;
}

/* --- colors --- */
.primary_color {
  color: #E11F60;
  /* color: #2551CB; */
}

.color_black {
  color: black;
}

.color_white {
  color: white;
}

.color_initial {
  color: #000;
  color: initial;
}

/* ---BACKGROUND_COLOR----- */
.bg_f1f1f1 {
  background-color: #f1f1f1;
}

.bg_white {
  background-color: white;
}

.bg_transparent {
  background-color: transparent;
}

/* ---MARGINS--- */
/* ------ auto ------ */
.margin_l_auto {
  margin-left: auto;
}

.margin_r_auto {
  margin-right: auto;
}

.margin_auto {
  margin: auto;
}

/* ------ 0 ------ */
.margin_0 {
  margin: 0;
}

.margin_t_0 {
  margin-top: 0rem;
}

.margin_b_0 {
  margin-bottom: 0rem;
}

.margin_b_3 {
  margin-bottom: 3px;
}

.margin_l_0 {
  margin-left: 0rem;
}

.margin_r_0 {
  margin-right: 0rem;
}

.margin_lr_0 {
  margin-left: 0rem;
  margin-right: 0rem;
}

.margin_tb_0 {
  margin-top: 0rem;
  margin-bottom: 0rem;
}

/* ------2------ */
.margin_lr_2 {
  margin-left: 2px;
  margin-right: 2px;
}

.margin_tb_2 {
  margin-top: 2px;
  margin-bottom: 2px;
}

/* ------ 4 ------ */
.margin_t_4 {
  margin-top: 4px;
}

.margin_r_4 {
  margin-right: 4px;
}

.margin_l_4 {
  margin-left: 4px;
}

.margin_lr_4 {
  margin: 0 4px;
}

.margin_b_4 {
  margin-bottom: 4px;
}

/* ------ 8 ------ */
.margin_8 {
  margin: 8px;
}

.margin_t_2 {
  margin-top: 2px;
}

.margin_t_8 {
  margin-top: 8px;
}

.margin_b_8 {
  margin-bottom: 8px;
}

.margin_l_8 {
  margin-left: 8px;
}

.margin_r_8 {
  margin-right: 8px;
}

.margin_lr_8 {
  margin-left: 8px;
  margin-right: 8px;
}

.margin_tb_8 {
  margin-top: 8px;
  margin-bottom: 8px;
}

/* ------ 10 ------ */
.margin_t_10 {
  margin-top: 10px;
}

.margin_t_16 {
  margin-top: 16px;
}

.margin_b_10 {
  margin-bottom: 10px;
}

.margin_l_10 {
  margin-left: 10px;
}

.margin_r_10 {
  margin-right: 10px;
}

.margin_lr_10 {
  margin-left: 10px;
  margin-right: 10px;
}

.margin_tb_10 {
  margin-top: 10px;
  margin-bottom: 10px;
}

/* ----------12---------- */
.margin_tb_12 {
  margin-top: 12px;
  margin-bottom: 12px;
}

.margin_t_12 {
  margin-top: 12px;
}

.margin_b_12 {
  margin-bottom: 12px;
}

/* ------16----- */
.margin_b_16 {
  margin-bottom: 16px;
}

.margin_tb_16 {
  margin-top: 16px;
  margin-bottom: 16px;
}

/* ------ 18 ------ */
.margin_t_18 {
  margin-top: 1.8rem;
}

/* ------ 20 ------ */
.margin_t_20 {
  margin-top: 20px;
}

.margin_b_2 {
  margin-bottom: 2px;
}

.margin_b_20 {
  margin-bottom: 20px;
}

.margin_tb_20 {
  margin: 20px 0;
  margin-top: 20px;
  margin-bottom: 20px;
}

.margin_lr_20 {
  margin-left: 20px;
  margin-right: 20px;
}

/* ---------------------- */
.margin_t_-4 {
  margin-top: -4px;
}

.margin_b_-4 {
  margin-bottom: -4px;
}

.margin_t_6 {
  margin-top: 6px;
}

.margin_tb_24 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.margin_t_24 {
  margin-top: 24px;
}

.margin_b_24 {
  margin-bottom: 24px;
}

.margin_b_28 {
  margin-bottom: 28px;
}

.margin_b_30 {
  margin-bottom: 30px;
}

.margin_t_32 {
  margin-top: 32px;
}

.margin_t_40 {
  margin-top: 40px;
}

.margin_t_44 {
  margin-top: 44px;
}

.margin_t_50 {
  margin-top: 50px;
}

.margin_t_64 {
  margin-top: 64px;
}

.margin_b_60 {
  margin-bottom: 60px;
}

/* PADDING */
.padding_auto {
  padding: auto;
}

.padding_b_0 {
  padding-bottom: 0px !important;
}

.padding_t_0 {
  padding-top: 0px;
}

.padding_tb_0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

/* ------ 4 ------ */
.padding_4 {
  padding: 4px;
}

.padding_t_4 {
  padding-top: 4px;
}

.padding_t_20 {
  padding-top: 20px;
}

.padding_b_4 {
  padding-bottom: 4px;
}

.padding_l_4 {
  padding-left: 4px;
}

.padding_l_8 {
  padding-left: 8px;
}

.padding_l_40 {
  padding-left: 40px !important;
}

.padding_r_4 {
  padding-right: 4px;
}

.padding_lr_4 {
  padding-left: 4px;
  padding-right: 4px;
}

.padding_tb_4 {
  padding-top: 4px;
  padding-bottom: 4px;
}

/* ------ 8 ------ */
.padding_8 {
  padding: 8px;
}

.padding_t_8 {
  padding-top: 8px;
}

.padding_b_8 {
  padding-bottom: 8px;
}

.padding_l_8 {
  padding-left: 8px;
}

.padding_l_16 {
  padding-left: 16px;
}

.padding_r_8 {
  padding-right: 8px;
}

.padding_lr_8 {
  padding-left: 8px;
  padding-right: 8px;
}

.padding_tb_8 {
  padding-top: 8px;
  padding-bottom: 8px;
}

/* ------ 10 ------ */
.padding_10 {
  padding: 10px;
}

.padding_t_10 {
  padding-top: 10px;
}

.padding_b_10 {
  padding-bottom: 10px;
}

.padding_l_10 {
  padding-left: 10px;
}

.padding_r_10 {
  padding-right: 10px;
}

.padding_lr_10 {
  padding-left: 10px;
  padding-right: 10px;
}

.padding_tb_10 {
  padding-top: 10px;
  padding-bottom: 10px;
}

/* -----12------ */
.padding_12 {
  padding: 12px;
}

.padding_t_12 {
  padding-top: 12px;
}

.padding_lr_12 {
  padding-left: 12px;
  padding-right: 12px;
}

/* -----14------ */
.padding_tb_14 {
  padding-top: 14px;
  padding-bottom: 14px;
}
.padding_lr_14 {
  padding-left: 14px;
  padding-right: 14px;
}

/* -----16------ */
.padding_16 {
  padding: 16px;
}

.padding_t_16 {
  padding-top: 16px;
}

.padding_b_16 {
  padding-bottom: 16px;
}

.padding_lr_16 {
  padding-left: 16px;
  padding-right: 16px;
}

/* --------20--------- */
.padding_20 {
  padding: 20px;
}

.padding_lr_20 {
  padding: 0 20px;
}

.padding_tb_20 {
  padding: 20px 0;
}

/* --------24--------- */
.padding_b_24 {
  padding-bottom: 24px;
}

.padding_t_24 {
  padding-top: 24px;
}

.padding_24 {
  padding: 24px;
}

.padding_b_32 {
  padding-bottom: 32px;
}

.padding_tb_36 {
  padding-top: 36px;
  padding-bottom: 36px;
}

.padding_40 {
  padding: 40px;
}

.padding_tb_40 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.padding_t_54 {
  padding-top: 54px;
}

.padding_t_64 {
  padding-top: 64px;
}

/* miscellaneous */
.shadow-1 {
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.09);
}

.break_all {
  word-break: break-all;
}

/* UnderLine */
.underline {
  text-decoration: underline;
}

.underline_none {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

/* container width fixes */
.container {
  width: 100%;
}

.no-scroll {
  overflow: hidden !important;
}

.overflow_hidden {
  overflow: hidden !important;
}

@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
}

@media (min-width: 1440px) {
  .container {
    max-width: 1200px;
  }
}

@media (min-width: 1536px) {
  .container {
    max-width: 1200px;
  }
}

.customScrollBar::-webkit-scrollbar {
  width: 2px;
  /* Width of the scrollbar */
  height: 2px;
  /* Height for horizontal scrollbar */
  margin-top: 8px;
}

/* Track (background) */
.customScrollBar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

/* Handle (scroll thumb) */
.customScrollBar::-webkit-scrollbar-thumb {
  background: #bcbcbc;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,2CAA2C;AAC7C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,iDAAiD;AACnD;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAA6B;EAA7B,6BAA6B;AAC/B;;AAEA;EACE,0BAAkB;EAAlB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAc;EAAd,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB,uBAAuB;AACvB;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EAId,gBAAgB;EAChB,mBAAmB;AAJrB;;AAOA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,oBAAoB;AACpB;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,0BAA0B;AAC5B;;AAEA;EACE,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,oCAAoC;EACpC,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":["/* Font family global */\n.font_Inter {\n  font-family: \"Inter\", sans-serif !important;\n}\n\n.font_DM_Sans {\n  font-family: \"DM Sans\", sans-serif !important;\n}\n\n.font_Inter_Tight {\n  font-family: \"Inter Tight\", sans-serif !important;\n}\n\n/* INLINE___BLOCK */\n.display_Inline_Block {\n  display: inline-block;\n}\n\n/* flex properties */\n.display_flex {\n  display: flex;\n}\n\n.row_flex {\n  display: flex;\n  flex-direction: row;\n}\n\n.col_flex {\n  display: flex;\n  flex-direction: column;\n}\n\n.row_flex_center {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.col_flex_center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.align_center {\n  display: flex;\n  align-items: center;\n}\n\n.displayAlignCenterJustifyBetween {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.justify_space_between {\n  display: flex;\n  justify-content: space-between;\n}\n\n.justify_space_around {\n  justify-content: space-around;\n}\n\n.justify_space_evenly {\n  justify-content: space-evenly;\n}\n\n.justify_center {\n  justify-content: center;\n}\n\n.justify_start {\n  justify-content: flex-start !important;\n}\n\n.justify_none {\n  justify-content: none;\n}\n\n.justify_normal {\n  justify-content: normal !important;\n}\n\n.justify_end {\n  justify-content: flex-end;\n}\n\n.align_items_center {\n  align-items: center;\n}\n\n.align_start {\n  align-items: flex-start;\n}\n\n.align_end {\n  align-items: flex-end;\n}\n\n.align_baseline {\n  display: flex;\n  align-items: baseline;\n}\n\n.flex_wrap {\n  flex-wrap: wrap;\n}\n\n/* ------GAP----- */\n.gap_2 {\n  gap: 2px;\n}\n\n.gap_4 {\n  gap: 4px;\n}\n\n.gap_6 {\n  gap: 6px;\n}\n\n.gap_8 {\n  gap: 8px;\n}\n\n.gap_10 {\n  gap: 10px;\n}\n\n.gap_12 {\n  gap: 12px;\n}\n\n.gap_14 {\n  gap: 14px;\n}\n\n.gap_16 {\n  gap: 16px;\n}\n\n.gap_20 {\n  gap: 20px;\n}\n\n.gap_24 {\n  gap: 24px;\n}\n\n.gap_30 {\n  gap: 30px;\n}\n\n.gap_36 {\n  gap: 36px;\n}\n\n.gap_50 {\n  gap: 50px;\n}\n\n/* -----BORDER-RADIUS------ */\n.borderRadius_6 {\n  border-radius: 6px;\n}\n\n.borderRadius_10 {\n  border-radius: 10px;\n}\n\n.borderRadius_16 {\n  border-radius: 16px;\n}\n\n.border_none {\n  border: none !important;\n}\n\n/* font weight */\n.font_300 {\n  font-weight: 300;\n}\n\n.font_400 {\n  font-weight: 400;\n}\n\n.font_500 {\n  font-weight: 500;\n}\n\n.font_600 {\n  font-weight: 600;\n}\n\n.font_700 {\n  font-weight: 700;\n}\n\n.font_bold {\n  font-weight: bold;\n}\n\n.font_normal {\n  font-weight: normal;\n}\n\n/* cursor properties */\n.cursor_pointer {\n  cursor: pointer;\n}\n\n.cursor_not_allowed {\n  cursor: not-allowed;\n}\n\n.cursor_default {\n  cursor: default;\n}\n\n/* position properties */\n.pos_relative {\n  position: relative;\n}\n\n.pos_absolute {\n  position: absolute;\n}\n\n.bottom_30 {\n  bottom: 3rem;\n}\n\n.zIndex_1 {\n  z-index: 1;\n}\n\n.zIndex_100000 {\n  z-index: 100000;\n}\n\n/* text align properties */\n.text_center {\n  text-align: center;\n}\n\n.text_left {\n  text-align: left;\n}\n\n.text_right {\n  text-align: right;\n}\n\n.text_capitalize {\n  text-transform: capitalize;\n}\n\n.text_uppercase {\n  text-transform: uppercase;\n}\n\n/* font-size */\n.fontSize_10 {\n  font-size: 10px;\n}\n\n.fontSize_12 {\n  font-size: 12px;\n}\n\n.fontSize_14 {\n  font-size: 14px;\n}\n\n.fontSize_15 {\n  font-size: 15px;\n}\n\n.fontSize_16 {\n  font-size: 16px;\n}\n\n.fontSize_18 {\n  font-size: 18px;\n}\n\n.fontSize_20 {\n  font-size: 20px;\n}\n\n.fontSize_22 {\n  font-size: 22px;\n}\n\n.fontSize_24 {\n  font-size: 24px;\n}\n\n.fontSize_36 {\n  font-size: 36px;\n}\n\n/* -----LINEHEIGHT------- */\n.lineHeight_normal {\n  line-height: normal;\n}\n\n.lineHeight_24 {\n  line-height: 24px;\n}\n\n.lineHeight_20 {\n  line-height: 20px;\n}\n\n/* height and width */\n.h_100 {\n  height: 100%;\n}\n\n.h_100vh {\n  height: 100vh;\n}\n\n.h_30px {\n  height: 30px;\n}\n\n.h_maxContent {\n  height: max-content;\n}\n\n.w_100 {\n  width: 100%;\n}\n\n.w_50 {\n  width: 50%;\n}\n\n.w_75 {\n  width: 75%;\n}\n\n.w_25 {\n  width: 25%;\n}\n\n.w_auto {\n  width: auto !important;\n}\n\n.w_fit_content {\n  width: fit-content !important;\n}\n\n.w_max_content {\n  width: max-content;\n}\n\n/* --- colors --- */\n.primary_color {\n  color: #E11F60;\n  /* color: #2551CB; */\n}\n\n.color_black {\n  color: black;\n}\n\n.color_white {\n  color: white;\n}\n\n.color_initial {\n  color: initial;\n}\n\n/* ---BACKGROUND_COLOR----- */\n.bg_f1f1f1 {\n  background-color: #f1f1f1;\n}\n\n.bg_white {\n  background-color: white;\n}\n\n.bg_transparent {\n  background-color: transparent;\n}\n\n/* ---MARGINS--- */\n/* ------ auto ------ */\n.margin_l_auto {\n  margin-left: auto;\n}\n\n.margin_r_auto {\n  margin-right: auto;\n}\n\n.margin_auto {\n  margin: auto;\n}\n\n/* ------ 0 ------ */\n.margin_0 {\n  margin: 0;\n}\n\n.margin_t_0 {\n  margin-top: 0rem;\n}\n\n.margin_b_0 {\n  margin-bottom: 0rem;\n}\n\n.margin_b_3 {\n  margin-bottom: 3px;\n}\n\n.margin_l_0 {\n  margin-left: 0rem;\n}\n\n.margin_r_0 {\n  margin-right: 0rem;\n}\n\n.margin_lr_0 {\n  margin-left: 0rem;\n  margin-right: 0rem;\n}\n\n.margin_tb_0 {\n  margin-top: 0rem;\n  margin-bottom: 0rem;\n}\n\n/* ------2------ */\n.margin_lr_2 {\n  margin-left: 2px;\n  margin-right: 2px;\n}\n\n.margin_tb_2 {\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n/* ------ 4 ------ */\n.margin_t_4 {\n  margin-top: 4px;\n}\n\n.margin_r_4 {\n  margin-right: 4px;\n}\n\n.margin_l_4 {\n  margin-left: 4px;\n}\n\n.margin_lr_4 {\n  margin: 0 4px;\n}\n\n.margin_b_4 {\n  margin-bottom: 4px;\n}\n\n/* ------ 8 ------ */\n.margin_8 {\n  margin: 8px;\n}\n\n.margin_t_2 {\n  margin-top: 2px;\n}\n\n.margin_t_8 {\n  margin-top: 8px;\n}\n\n.margin_b_8 {\n  margin-bottom: 8px;\n}\n\n.margin_l_8 {\n  margin-left: 8px;\n}\n\n.margin_r_8 {\n  margin-right: 8px;\n}\n\n.margin_lr_8 {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n\n.margin_tb_8 {\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n\n/* ------ 10 ------ */\n.margin_t_10 {\n  margin-top: 10px;\n}\n\n.margin_t_16 {\n  margin-top: 16px;\n}\n\n.margin_b_10 {\n  margin-bottom: 10px;\n}\n\n.margin_l_10 {\n  margin-left: 10px;\n}\n\n.margin_r_10 {\n  margin-right: 10px;\n}\n\n.margin_lr_10 {\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\n.margin_tb_10 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n/* ----------12---------- */\n.margin_tb_12 {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n\n.margin_t_12 {\n  margin-top: 12px;\n}\n\n.margin_b_12 {\n  margin-bottom: 12px;\n}\n\n/* ------16----- */\n.margin_b_16 {\n  margin-bottom: 16px;\n}\n\n.margin_tb_16 {\n  margin-top: 16px;\n  margin-bottom: 16px;\n}\n\n/* ------ 18 ------ */\n.margin_t_18 {\n  margin-top: 1.8rem;\n}\n\n/* ------ 20 ------ */\n.margin_t_20 {\n  margin-top: 20px;\n}\n\n.margin_b_2 {\n  margin-bottom: 2px;\n}\n\n.margin_b_20 {\n  margin-bottom: 20px;\n}\n\n.margin_tb_20 {\n  margin: 20px 0;\n}\n\n.margin_tb_20 {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.margin_lr_20 {\n  margin-left: 20px;\n  margin-right: 20px;\n}\n\n/* ---------------------- */\n.margin_t_-4 {\n  margin-top: -4px;\n}\n\n.margin_b_-4 {\n  margin-bottom: -4px;\n}\n\n.margin_t_6 {\n  margin-top: 6px;\n}\n\n.margin_tb_24 {\n  margin-top: 24px;\n  margin-bottom: 24px;\n}\n\n.margin_t_24 {\n  margin-top: 24px;\n}\n\n.margin_b_24 {\n  margin-bottom: 24px;\n}\n\n.margin_b_28 {\n  margin-bottom: 28px;\n}\n\n.margin_b_30 {\n  margin-bottom: 30px;\n}\n\n.margin_t_32 {\n  margin-top: 32px;\n}\n\n.margin_t_40 {\n  margin-top: 40px;\n}\n\n.margin_t_44 {\n  margin-top: 44px;\n}\n\n.margin_t_50 {\n  margin-top: 50px;\n}\n\n.margin_t_64 {\n  margin-top: 64px;\n}\n\n.margin_b_60 {\n  margin-bottom: 60px;\n}\n\n/* PADDING */\n.padding_auto {\n  padding: auto;\n}\n\n.padding_b_0 {\n  padding-bottom: 0px !important;\n}\n\n.padding_t_0 {\n  padding-top: 0px;\n}\n\n.padding_tb_0 {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n\n/* ------ 4 ------ */\n.padding_4 {\n  padding: 4px;\n}\n\n.padding_t_4 {\n  padding-top: 4px;\n}\n\n.padding_t_20 {\n  padding-top: 20px;\n}\n\n.padding_b_4 {\n  padding-bottom: 4px;\n}\n\n.padding_l_4 {\n  padding-left: 4px;\n}\n\n.padding_l_8 {\n  padding-left: 8px;\n}\n\n.padding_l_40 {\n  padding-left: 40px !important;\n}\n\n.padding_r_4 {\n  padding-right: 4px;\n}\n\n.padding_lr_4 {\n  padding-left: 4px;\n  padding-right: 4px;\n}\n\n.padding_tb_4 {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n\n/* ------ 8 ------ */\n.padding_8 {\n  padding: 8px;\n}\n\n.padding_t_8 {\n  padding-top: 8px;\n}\n\n.padding_b_8 {\n  padding-bottom: 8px;\n}\n\n.padding_l_8 {\n  padding-left: 8px;\n}\n\n.padding_l_16 {\n  padding-left: 16px;\n}\n\n.padding_r_8 {\n  padding-right: 8px;\n}\n\n.padding_lr_8 {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n\n.padding_tb_8 {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n/* ------ 10 ------ */\n.padding_10 {\n  padding: 10px;\n}\n\n.padding_t_10 {\n  padding-top: 10px;\n}\n\n.padding_b_10 {\n  padding-bottom: 10px;\n}\n\n.padding_l_10 {\n  padding-left: 10px;\n}\n\n.padding_r_10 {\n  padding-right: 10px;\n}\n\n.padding_lr_10 {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.padding_tb_10 {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n/* -----12------ */\n.padding_12 {\n  padding: 12px;\n}\n\n.padding_t_12 {\n  padding-top: 12px;\n}\n\n.padding_lr_12 {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n/* -----14------ */\n.padding_tb_14 {\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n.padding_lr_14 {\n  padding-left: 14px;\n  padding-right: 14px;\n}\n\n/* -----16------ */\n.padding_16 {\n  padding: 16px;\n}\n\n.padding_t_16 {\n  padding-top: 16px;\n}\n\n.padding_b_16 {\n  padding-bottom: 16px;\n}\n\n.padding_lr_16 {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n/* --------20--------- */\n.padding_20 {\n  padding: 20px;\n}\n\n.padding_lr_20 {\n  padding: 0 20px;\n}\n\n.padding_tb_20 {\n  padding: 20px 0;\n}\n\n/* --------24--------- */\n.padding_b_24 {\n  padding-bottom: 24px;\n}\n\n.padding_t_24 {\n  padding-top: 24px;\n}\n\n.padding_24 {\n  padding: 24px;\n}\n\n.padding_b_32 {\n  padding-bottom: 32px;\n}\n\n.padding_tb_36 {\n  padding-top: 36px;\n  padding-bottom: 36px;\n}\n\n.padding_40 {\n  padding: 40px;\n}\n\n.padding_tb_40 {\n  padding-top: 40px;\n  padding-bottom: 40px;\n}\n\n.padding_t_54 {\n  padding-top: 54px;\n}\n\n.padding_t_64 {\n  padding-top: 64px;\n}\n\n/* miscellaneous */\n.shadow-1 {\n  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.09);\n}\n\n.break_all {\n  word-break: break-all;\n}\n\n/* UnderLine */\n.underline {\n  text-decoration: underline;\n}\n\n.underline_none {\n  text-decoration-line: none;\n}\n\n/* container width fixes */\n.container {\n  width: 100%;\n}\n\n.no-scroll {\n  overflow: hidden !important;\n}\n\n.overflow_hidden {\n  overflow: hidden !important;\n}\n\n@media (min-width: 640px) {\n  .container {\n    max-width: 640px;\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    max-width: 768px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .container {\n    max-width: 1024px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1200px;\n  }\n}\n\n@media (min-width: 1440px) {\n  .container {\n    max-width: 1200px;\n  }\n}\n\n@media (min-width: 1536px) {\n  .container {\n    max-width: 1200px;\n  }\n}\n\n.customScrollBar::-webkit-scrollbar {\n  width: 2px;\n  /* Width of the scrollbar */\n  height: 2px;\n  /* Height for horizontal scrollbar */\n  margin-top: 8px;\n}\n\n/* Track (background) */\n.customScrollBar::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n/* Handle (scroll thumb) */\n.customScrollBar::-webkit-scrollbar-thumb {\n  background: #bcbcbc;\n  border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
